// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5609229f","453":"d9749a7d","455":"51e7fc9e","977":"02722cfc"}[chunkId] + ".chunk.js";
};